import { createSlice } from "@reduxjs/toolkit";

export const dashboardReviewsSlice = createSlice({
    name: 'dashboardReviews',

    initialState: {

        payload: {
           users: 12,
           inventory: 1500055,
            feedbacks: 3,
            report: 'A report from IT'
        }
    },
    reducers: {
        dashboardReviews: (state, action) => {
           state.payload = action.payload
        },
    }
});

export const {dashboardReviews} = dashboardReviewsSlice.actions
export default dashboardReviewsSlice.reducer